__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "bizsignupnodeweb";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@paypalcorp/pp-react", "7.12.0", () => (Promise.all([__webpack_require__.e("vendors"), __webpack_require__.e("node_modules_paypalcorp_pp-react_dist_paypalcorp_pp-react_esm_js-_b2e90")]).then(() => (() => (__webpack_require__(/*! ./node_modules/@paypalcorp/pp-react/dist/@paypalcorp/pp-react.esm.js */ "./node_modules/@paypalcorp/pp-react/dist/@paypalcorp/pp-react.esm.js"))))));
			register("react-dom", "16.14.0", () => (Promise.all([__webpack_require__.e("vendors"), __webpack_require__.e("node_modules_react-dom_index_js-_8bc81")]).then(() => (() => (__webpack_require__(/*! ./node_modules/react-dom/index.js */ "./node_modules/react-dom/index.js"))))));
			register("react-router", "3.2.6", () => (Promise.all([__webpack_require__.e("vendors"), __webpack_require__.e("node_modules_react-router_es_index_js-_76dc0")]).then(() => (() => (__webpack_require__(/*! ./node_modules/react-router/es/index.js */ "./node_modules/react-router/es/index.js"))))));
			register("react", "16.14.0", () => (Promise.all([__webpack_require__.e("vendors"), __webpack_require__.e("node_modules_react_index_js-_ab5b0")]).then(() => (() => (__webpack_require__(/*! ./node_modules/react/index.js */ "./node_modules/react/index.js"))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};